import { takeLatest, put, call, fork } from 'redux-saga/effects';

import { restClient } from 'config/store/configureStore';

import * as actions from 'modules/followUp/actions/model';
import * as types from 'modules/followUp/actionTypes';

import dashboardSaga from './dashboard.saga';

function* getModel({ payload, meta }) {
  const { request } = payload;
  try {
    const { data: model } = yield call(restClient.request, request);
    yield put(actions.getFollowUpModelSuccess(model, meta));
  } catch (error) {
    yield put(actions.getFollowUpModelFailure(error, meta));
  }
}

export default function* followUpModelSagas() {
  yield takeLatest(types.GET_FOLLOW_UP_MODEL_REQUEST, getModel);

  yield fork(dashboardSaga);
}
